import { defineNuxtRouteMiddleware, navigateTo, } from 'nuxt/app';

const redirects = [
  // promo redirect start
  // labor day sale redirects
  {
    from: /^\/FLASH30/i,
    to: '/courses/SPRING-SALE-2025?code=FLASH30&utm_source=Postcard&utm_medium=RAQ-Struggling-States&utm_campaign=SPRING-SALE-2025',
  },
  // labor day sale redirects end
  // promo redirect end
  // sib redirect start
  {
    from: /^\/advantage/i,
    to: '/courses/advantage-sib',
  },
  {
    from: /^\/INFO40/i,
    to: '/courses/advantage-sib?code=/INFO40',
  },
  // sib redirect end
  {
    from: /^\/metro\/.+/i,
    to: '/',
  },
  {
    from: /^\/about-us/i,
    to: '/about',
  },
  {
    from: /^\/hospitals/i,
    to: '/group-sales',
  },
  {
    from: /^\/schools/i,
    to: '/group-sales/schools',
  },
  {
    from: /^\/group-learning\/compliance-leadership-training/i,
    to: '/group-sales',
  },
  {
    from: /^\/group-learning\/(hep|home-exercise-program)/i,
    to: '/group-sales/hep',
  },
  {
    from: /^\/group-learning\/(.+)$/i,
    to: (match) => `/group-sales/${match[1]}`,
  },
  {
    from: /^\/group-learning/i,
    to: '/group-sales',
  },
  {
    from: /^\/group-sales\/rewards\/SGLOAWEBH17133/i,
    to: '/group-sales/rewards/SGLVAH17133',
  },
  {
    from: /^\/(ivyrehab|edfund|synchrony)$/i,
    to: (match) => `/group-sales/client/${match[1]}`,
  },
  {
    from: /^\/group-sales\/client\/ivyrehab/i,
    to: '/group-sales/rewards/SGLAAJIR57215',
  },
  {
    from: /^\/group-sales\/client\/wvbot/i,
    to: '/group-sales/rewards/SGLOALIWRP31683',
  },
  {
    from: /^\/live[-]{0,1}webinars/i,
    to: '/courses/format/webinar',
  },
  {
    from: /^\/live(?!-ce-course-states|\/terms|\/in-person-waiver|\/live-registration)/i,
    to: '/courses/format/live',
  },
  {
    from: /^\/signup/i,
    to: '/subscription/pricing',
  },
  {
    from: /^\/subscription\/terms/i,
    to: '/subscription/tc',
  },
  {
    from: /^\/subscription\/(online-access|onlineaccess-monthly|onlineaccess)/i,
    to: '/subscription/subscription-v2',
  },
  {
    from: /^\/live\/waiver/i,
    to: '/live/terms',
  },
  {
    from: /^\/ce\/(body-regions|documentation-and-compliance|ethics-and-jurisprudence|geriatrics|neurology|orthopedics|pediatrics)$/i,
    to: (match) => `/courses/category/${match[1]}`,
  },
  {
    from: /^\/courses\/category\/documentation-and-compliance/i,
    to: '/courses/category/documentation',
  },
  {
    from: /^\/ce\/live-courses/i,
    to: '/courses/format/live',
  },
  {
    from: /^\/ce\/live-webinars/i,
    to: '/courses/format/webinar',
  },
  {
    from: /^\/ce\/(live-streaming|live|webinar|video|text)$/i,
    to: (match) => `/courses/format/${match[1]}`,
  },
  {
    from: /^\/ce\/(physical-therapist|occupational-therapist|speech-language-pathologist|educator|athletic-trainer|other-professionals)$/i,
    to: (match) => `/courses/profession/${match[1]}`,
  },
  {
    //  // don't want to match "cert" or ce-acceleration
    from: /^\/(search|(ce(?!(rt|-acceleration))))/i,
    to: '/courses',
  },
  {
    from: /^\/scorm\/check-ce(?:\.jsp)(\?.*)$/i,  // Simpler regex
    to: (match) => `https://old.summit-education.com/scorm/check-ce.jsp/${match[2]}`,
  },
  {
    from: /^\/scorm\/(.*)$/i,
    to: (match) => `https://old.summit-education.com/scorm/${match[1]}`,
  },
  {
    from: /^\/faq/i,
    to: 'http://support.summit-education.com/hc/en-us',
  },
  {
    from: /^\/subscription[/]{0,1}$/i,
    to: '/subscription/subscription-v2',
  },
  {
    from: /^\/c\/(.+)$/i,
    to: (match) => `/course/${match[1]}`,
  },
  {
    from: /^\/w\/(.+)$/i,
    to: (match) => `/s/${match[1]}`,
  },
  {
    from: /^\/livestreams/i,
    to: '/courses/format/live-streaming',
  },
  {
    from: /^\/inperson/i,
    to: '/courses/format/live',
  },
  {
    from: /^\/online$/i,
    to: '/courses/format/video',
  },
  {
    from: /^\/podcast/i,
    to: '/courses/format/podcast',
  },
  {
    from: /^\/courses\/profession$/i,
    to: '/profession',
  },
  {
    from: /^\/courses\/category$/i,
    to: '/topics',
  },
  {
    from: /^\/courses\/format$/i,
    to: '/formats',
  },
  {
    from: /^\/slp$/i,
    to: '/courses/profession/speech-language-pathologist',
  },
  {
    from: /^\/geriatrics$/i,
    to: '/courses/category/geriatrics',
  },
  {
    from: /^\/neurology$/i,
    to: '/courses/category/neurology',
  },
  {
    from: /^\/orthopedics$/i,
    to: '/courses/category/orthopedics',
  },
  {
    from: /^\/pediatrics$/i,
    to: '/courses/category/pediatrics',
  },
  {
    from: /^\/state-requirement$/i,
    to: '/courses/category/state-requirement',
  },
  {
    from: /^\/free-course$/i,
    to: '/courses/free-course',
  },
  {
    from: /^\/free/i,
    to: '/courses/free-course',
  },
  {
    from: /^\/hep/i,
    to: '/subscription/hep',
  },
  {
    from: /^\/summit-ce-webathon/i,
    to: '/ce-acceleration-virtual-conference',
  },
];

function isAuthenticated() {
  const { status } = useAuth();
  return status.value === 'authenticated';
}

/**
 * middleware: https://nuxt.com/docs/guide/directory-structure/middleware
 */
export default defineNuxtRouteMiddleware((to, from) => {
  console.log('ROUTER MIDDLEWARE:', to, from);
  if (to.path.includes('account') && isAuthenticated() === false) {
    return navigateTo({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
// Get the full path including query parameters
  const fullUrlPath = to.fullPath;

  const redirectPage = redirects.filter(redirect => to.path.match(redirect.from));
  if (redirectPage.length > 0) {
    const redirect = redirectPage[0];
    const match = to.path.match(redirect.from);

    // Calculate destination
    let destination;
    if (typeof redirect.to === 'function') {
      // Pass the match for path transformation AND the full URL context
      destination = redirect.to(match, { fullPath: fullUrlPath, query: to.query });
    } else {
      destination = redirect.to;
    }

    // For external redirects, preserve query params
    if (destination.startsWith('http') && Object.keys(to.query).length > 0) {
      const queryString = new URLSearchParams(to.query).toString();
      const separator = destination.includes('?') ? '&' : '?';
      destination = queryString ? `${destination}${separator}${queryString}` : destination;
    }

    return navigateTo(destination, { external: destination.startsWith('http') });
  }
});
